import authorizedFetch from "../utilities/authorizedFetch";
import { BASE_URL } from "../config/constants";

const endpointURL = `${BASE_URL}/answer`;

export const create = payload => {
  return authorizedFetch(`${endpointURL}/create`, {
    method: "POST",
    body: JSON.stringify(payload),
    headers: {
      "Content-Type": "application/json"
    }
  });
};



// WEBPACK FOOTER //
// ./src/api/answer.js